import React from "react"
import { useLocation } from "react-router-dom"

import { isInPlaceEditingActive } from "scrivito"
import {
  PROJECT_DETAILS,
  SHARED_PROJECT_DETAILS
} from "shared/constants/permalinks"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"
import { NoComponentPage } from "shared/ui/no-component-page/NoComponentPage"

import { ProjectPageLoader } from "pages/project-page/ProjectPageLoader"

export const PageLoaderFactory = React.memo(() => {
  const { pathname } = useLocation()
  const permalink = pathname.split("/").pop()
  switch (permalink) {
    case PROJECT_DETAILS:
    case SHARED_PROJECT_DETAILS:
      return <ProjectPageLoader />
    default:
      return isInPlaceEditingActive() ? <NoComponentPage /> : <LoadingSpinner />
  }
})
